
"use client";

import { Avatar, Dropdown, Navbar } from "flowbite-react";
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LogoutLink from '../../components/Logout';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import { AuthContext } from "../../hooks/AuthContext";
import { getAssetUrl } from '../../lib/api';

export default function Menu() {
  useContext(AuthContext);

  let imgPerfil = '';
  
  //if auth mostrar img cuenta google
  const user = JSON.parse(localStorage.getItem('User'));

  return (
    <Navbar fluid rounded>
      <Navbar.Brand href="#">
        <Link to="/app" className="text-gray-800" active="true"><img src={getAssetUrl('logo_exxis.png')} className="mr-3 h-6 sm:h-9" alt="Exxis Logo"/></Link>
        <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Panel soluciones</span>
      </Navbar.Brand>
      <div className="flex md:order-2">
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="Login Google" img={imgPerfil} rounded />
          }
          className="m-2"
        >
          <Dropdown.Header>
            <span className="block text-sm">{user?.name || ''}</span>
            <span className="block truncate text-sm font-medium">{user?.email}</span>
          </Dropdown.Header>
          <Dropdown.Item>Perfil</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>
            <LogoutLink />
          </Dropdown.Item>
        </Dropdown>
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        <Navbar>
          <Link to="/app" className="text-gray-800" active="true">Soluciones</Link>
        </Navbar>
        <PermissionWrapper requiredPermissions={['menu_report']}>
          <Navbar>
            <Link to="dashboard" className="text-gray-800">Dashboard</Link>
          </Navbar>
        </PermissionWrapper>

        <PermissionWrapper requiredPermissions={['menu_resource']}>
          <Navbar>
            <Link to="recursos" className="text-gray-800">Centro de Recursos</Link>
          </Navbar>
        </PermissionWrapper>

        <Navbar>
          <Dropdown label="Gestión documental" inline>
            <Link to="proyectos" className="text-gray-800">
              <Dropdown.Item>
                Proyectos
              </Dropdown.Item>
            </Link>
            <Link to="clientes" className="text-gray-800">
              <Dropdown.Item>
                Clientes
              </Dropdown.Item>
            </Link>
            <Link to="entregables" className="text-gray-800">
              <Dropdown.Item>
                Entregables
              </Dropdown.Item>
            </Link>
          </Dropdown>
        </Navbar>
        
        <PermissionWrapper requiredPermissions={['menu_config']}>
          <Navbar>
              <Dropdown label="Configuración" inline>
                    <PermissionWrapper requiredPermissions={['menu_solutions']}>
                      <Link to="soluciones" className="text-gray-800">
                        <Dropdown.Item>
                            Soluciones
                        </Dropdown.Item>
                      </Link>
                    </PermissionWrapper>
                    <PermissionWrapper requiredPermissions={['menu_area']}>
                      <Link to="areas" className="text-gray-800">
                        <Dropdown.Item>
                            Areas
                        </Dropdown.Item>
                      </Link>
                    </PermissionWrapper>
                    <PermissionWrapper requiredPermissions={['menu_user']}>
                      <Link to="usuarios" className="text-gray-800">
                        <Dropdown.Item>
                            Usuarios
                        </Dropdown.Item>
                      </Link>
                    </PermissionWrapper>
                    <PermissionWrapper requiredPermissions={['menu_roles']}>
                      <Link to="roles" className="text-gray-800">
                        <Dropdown.Item>
                            Roles
                        </Dropdown.Item>
                      </Link>
                    </PermissionWrapper>
                    <PermissionWrapper requiredPermissions={['menu_permission']}>
                      <Link to="permisos" className="text-gray-800">
                        <Dropdown.Item>
                            Permisos
                        </Dropdown.Item>
                      </Link>
                    </PermissionWrapper>
              </Dropdown>
          </Navbar>
        </PermissionWrapper>
      </Navbar.Collapse>
    </Navbar>
  );
}
